import { useContext, useEffect } from "react"
import ModelElements from "../ModelElements"
import { ProductModelProps } from "../ModelViewerProduct"
import ProductTextureContext from "../_contexts/ProductTextureContext"
import useGLB from "../_hooks/useGLB"

export default function PremiumDrawstringBag(props: ProductModelProps) {
    const url = new URL('@resources/3d-models/glb/premium-drawstring-bag.glb', import.meta.url);
    const model = useGLB(url)
    const elements = model.scene.children
    const [productTexture] = useContext(ProductTextureContext)
    
    // Apply lab texture
    useEffect(() => {
        if(!elements || !elements[1]?.material) return

        elements[1].material.map = productTexture
        elements[1].material.map.flipY = false
        elements[1].material.map.needsUpdate = true
    }, [productTexture, elements])
    
    return <ModelElements scene={model.scene}/>
}